import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M14.2236 13.3193C15.0416 12.6516 16.0853 12.25 17.2236 12.25C19.847 12.25 21.9736 14.3766 21.9736 17C21.9736 19.6234 19.847 21.75 17.2236 21.75C14.7692 21.75 12.7499 19.8883 12.5 17.5H14.0117C14.2522 19.0576 15.5987 20.25 17.2236 20.25C19.0186 20.25 20.4736 18.7949 20.4736 17C20.4736 15.2051 19.0186 13.75 17.2236 13.75C16.4341 13.75 15.7106 14.0318 15.1475 14.5H16.7236V16H12.7236V12H14.2236V13.3193Z",
      fill: "currentColor"
    }),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17 3.25C17.4142 3.25 17.75 3.58579 17.75 4V5.25H19C19.9665 5.25 20.75 6.0335 20.75 7V10.75H4.75V19C4.75 19.1381 4.86193 19.25 5 19.25H11.75V20.75H5C4.0335 20.75 3.25 19.9665 3.25 19V7C3.25 6.0335 4.0335 5.25 5 5.25H6.25V4C6.25 3.58579 6.58579 3.25 7 3.25C7.41421 3.25 7.75 3.58579 7.75 4V5.25H11.25V4C11.25 3.58579 11.5858 3.25 12 3.25C12.4142 3.25 12.75 3.58579 12.75 4V5.25H16.25V4C16.25 3.58579 16.5858 3.25 17 3.25ZM5 6.75C4.86193 6.75 4.75 6.86193 4.75 7V9.25H19.25V7C19.25 6.86193 19.1381 6.75 19 6.75H17.75V7C17.75 7.41421 17.4142 7.75 17 7.75C16.5858 7.75 16.25 7.41421 16.25 7V6.75H12.75V7C12.75 7.41421 12.4142 7.75 12 7.75C11.5858 7.75 11.25 7.41421 11.25 7V6.75H7.75V7C7.75 7.41421 7.41421 7.75 7 7.75C6.58579 7.75 6.25 7.41421 6.25 7V6.75H5Z",
      fill: "currentColor"
    })
  ]))
}